import { useRouter, useRoute, navigateTo } from 'nuxt/app';
import { buildPageMetaTitle, robotsRuleFromSeo } from '~/utils/seo';

export default function useSetHead(seo: object, typePage: string, product: object) {
    const config = useRuntimeConfig();
    const route = useRoute();
    const router = useRouter();
    if (route.path !== route.path.toLowerCase()) {
        navigateTo(route.path.toLowerCase(), { replace: true });
        return;
    }
    const canonicalUrl = useCanonicalUrl();
    if (!seo) {
        useHead({
            title: 'Ballegooyen Modes',
            link: [
                {
                    rel: 'canonical',
                    href: canonicalUrl,
                },
            ],
        });
        return;
    }

    // Only override the robots rule when Shopware asks for it; nuxt-robots keeps its own default
    // (index/follow on production, noindex on preview builds) for every other page.
    const robotsRule = robotsRuleFromSeo(seo);
    if (robotsRule) {
        useRobotsRule(robotsRule);
    }

    if (typePage === 'detail') {
        const properties = product?.product?.properties;

        const targetProperty = properties.find(prop => prop.groupId === config.public.shopwareColorPropertyId);

        //TODO add manufactory / brand in front of the product name
        let productName = product.product.name;
        const manufacturerName = product?.product?.manufacturer?.name ?? '';

        if (manufacturerName) {
            productName = manufacturerName + ' ' + productName;
        }
        let colorName = '';
        if (targetProperty) {
            colorName = targetProperty?.translated?.name + ' | ';
        }

        useHead({
            title: productName + ' | ' + colorName + 'Ballegooyen Modes',
            meta: [
                {
                    name: 'description',
                    content:
                        'Shop nu jouw ' +
                        product.product.name +
                        ' online of in onze winkel | Gratis verzending | Voor 15.00 besteld, vandaag verzonden | 5% spaarbonus',
                },
            ],
            link: [
                {
                    rel: 'canonical',
                    href: canonicalUrl,
                },
            ],
        });
    } else {
        const snippetsStore = useSnippetsStore();
        const snippets = snippetsStore.snippets;
        // removes duplicate back to back BallegooyenModes tags
        const metaTitle = buildPageMetaTitle(seo.metaTitle, snippets['headless.metatitle']);
        useHead({
            title: metaTitle,
            meta: [
                {
                    name: 'description',
                    content: seo.metaDescription,
                },
            ],
            link: [
                {
                    rel: 'canonical',
                    href: canonicalUrl,
                },
            ],
        });
    }
}
